// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { TenantBaseApi } from "api/TenantSlug/TenantBaseApi.ts";

import GetLanguagesResponse = App.Http.Responses.Language.GetLanguagesResponse;
import GetLanguageResponse = App.Http.Responses.Language.GetLanguageResponse;

class LanguageApi extends TenantBaseApi {
    /**
     * Get list of Languages
     *
     * - Request: -
     * - Response: GetLanguagesResponse
     */
    async index(): Promise<GetLanguagesResponse> {
        return await this.get<GetLanguagesResponse, void>("/languages");
    }

    /**
     * Get specific Language
     *
     * - Request: { id: number }
     * - Response: GetLanguageResponse
     */
    async show(languageId: string): Promise<GetLanguageResponse> {
        return await this.get<GetLanguageResponse, void>(`/languages/${languageId}`);
    }
}

export const languageApi = new LanguageApi();
